var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('myHead'),_c('orderlist'),_vm._m(0),_c('div',{staticClass:"login"},[_c('button',{on:{"click":_vm.LoginOut}},[_vm._v(" 退出登录")])])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service"},[_c('p',[_vm._v("咨询热线：4000778183")]),_c('p',[_vm._v("(周一至周五9:00-18:00)")]),_c('p',[_c('span',[_vm._v("客维智能科技(广州)有限公司")])])])
}]

export { render, staticRenderFns }